export const prefixCls = 'icloud-ui-form';
//# sourceMappingURL=es/utils/config.js.map